export const LOCALES = ['hr', 'en', 'de', 'it', 'sr', 'sl', 'tr'] as const

export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'hr'

export const LOCALE_META: Record<
  Locale,
  { label: string; endonym: string; htmlLang: string; hrefLang: string; dir: 'ltr' }
> = {
  hr: { label: 'HR', endonym: 'Hrvatski', htmlLang: 'hr', hrefLang: 'hr-HR', dir: 'ltr' },
  en: { label: 'EN', endonym: 'English', htmlLang: 'en', hrefLang: 'en', dir: 'ltr' },
  de: { label: 'DE', endonym: 'Deutsch', htmlLang: 'de', hrefLang: 'de-DE', dir: 'ltr' },
  it: { label: 'IT', endonym: 'Italiano', htmlLang: 'it', hrefLang: 'it-IT', dir: 'ltr' },
  sr: { label: 'SR', endonym: 'Srpski', htmlLang: 'sr-Latn', hrefLang: 'sr-Latn-RS', dir: 'ltr' },
  sl: { label: 'SL', endonym: 'Slovenščina', htmlLang: 'sl', hrefLang: 'sl-SI', dir: 'ltr' },
  tr: { label: 'TR', endonym: 'Türkçe', htmlLang: 'tr', hrefLang: 'tr-TR', dir: 'ltr' },
}

export const isLocale = (value: string): value is Locale =>
  (LOCALES as readonly string[]).includes(value)
